import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/pages/Home'
import About from '@/pages/About'
import History from '@/pages/History'
import Product from '@/pages/Product'
import News from '@/pages/News'
import Knowledge from '@/pages/Knowledge'
import Contact from '@/pages/Contact'
import NewsDetails from '@/pages/News/NewsDetails'
import KnowledgeDetails from '@/pages/Knowledge/KnowledgeDetails'
import NewsList from '@/pages/News/NewsList'
import KnowledgeList from '@/pages/Knowledge/KnowledgeList'
import ProductList from '@/pages/Product/ProductList'
import ProductDetails from '@/pages/Product/ProductDetails'
import VideoPlayer from '../components/Pagination/VideoPlayer.vue'

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      name: "home",
      path: '/home',
      component: Home,
    },
    {
      name: "about",
      path: '/about',
      component: About
    },
    {
      name: "history",
      path: '/history',
      component: History
    },
    {
      name: "product",
      path: '/product',
      component: Product,
      children: [
        { path: "productlist", component: ProductList },
        { name: "productdetails", path: "productdetails", component: ProductDetails },
        { path: '/product', redirect: "/product/productlist" }
      ]
    },
    {
      name: "news",
      path: '/news',
      component: News,
      children: [
        { path: "newsdetails", component: NewsDetails },
        { path: "newslist", component: NewsList },
        { path: '/news', redirect: "/news/newslist" }
      ]
    },
    {
      name: "knowledge",
      path: '/knowledge',
      component: Knowledge,
      children: [
        { path: "knowledgedetails", component: KnowledgeDetails },
        { path: "knowledgelist", component: KnowledgeList },
        { path: '/knowledge', redirect: "/knowledge/knowledgelist" }
      ]
    },
    {
      name: "contact",
      path: '/contact',
      component: Contact
    },
    // 关键：添加VideoPlayer路由配置
    {
      name: "VideoPlayer", // 名称必须是"VideoPlayer"，与跳转时一致
      path: '/video/:id', // 动态参数id，匹配/video/1、/video/2等路径
      component: VideoPlayer // 对应视频播放组件
    },
    {
      path: '/',
      redirect: "/home"
    }
  ],
  scrollBehavior() {
    return { top: 0 }
  },
})